import { registerDecorator, type ValidationOptions } from 'class-validator';
import { isTempImageId } from '../image';

/**
 * Class validator that checks if a uuid starts with temp-.
 * @param validationOptions
 * @returns
 */
export function IsTempImageId(validationOptions?: ValidationOptions) {
  return function (object: unknown, propertyName: string) {
    registerDecorator({
      name: IsTempImageId.name,
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown) {
          return isTempImageId(value as string);
        },
      },
    });
  };
}
